import { metadataState } from "components/organisms/manuscript/editor/latex/language";
import { extendRequiredParameter } from "./apply.js";
import { maybeGetSectionForOption } from "./sections.js";
export function buildReferenceCompletions(completions, context) {
    const metadata = context.state.field(metadataState, false);
    if (!metadata) {
        return;
    }
    for (const referenceKey of metadata.referenceKeys) {
        completions.references.push({
            type: "reference",
            label: referenceKey,
            extend: extendRequiredParameter,
            section: maybeGetSectionForOption(context, "references"),
            deduplicate: {
                key: referenceKey,
                priority: 1,
            },
        });
    }
}
